'use strict';

function MoneyArticleGallery() {
  this.id = null;
  this.node = null;
  this.extends = [_AccountController, ArticleGallery];

  this.contentId = ''; // 'money' (defined in pug file)

  this.init = function () {
    this._super();

    this.initPage();
  };

  this.initPage = function () {
    this.initArticleGallery();
  };

  this.initAllReady = function () {};

  this.destroy = function () {
    this.destroyArticleGallery();
  };
}